const Gender = {
    male: 'male',
    female: 'female',
    unknown: 'unknown'
}

export default Gender;